export enum DocumentTemplateTypeEnum {
  PR,
  RFP,
  RFQ,
  PO,
}

export const approvalStatusArray = Object.keys(DocumentTemplateTypeEnum)
  .filter((key) => isNaN(Number(key))) // Filter out numeric keys
  .map((key) => ({
    value:
      DocumentTemplateTypeEnum[key as keyof typeof DocumentTemplateTypeEnum], // Enum value
    label: key, // Enum name
  }));
